import t from '@jetshop/intl';
import {
  DropdownMenu,
  DropdownMenuButton,
  DropdownMenuItem,
  DropdownMenuItems
} from '@jetshop/ui/DropdownMenu';
import SortOrder from '@jetshop/ui/SortOrder/SortOrder';
import * as React from 'react';
import { ReactComponent as Carot } from '@jetshop/ui/svg/Carrot.svg';
import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';

function SortOrderDropdown({ sortOrders }) {
  return (
    <SortOrder sortOrders={sortOrders}>
      {props => (
        <SortMenu
          changeSortOrder={props.changeSortOrder}
          direction={props.direction}
          sortOrder={props.sortOrder}
          mappedSortOrder={props.mappedSortOrder}
        />
      )}
    </SortOrder>
  );
}

function SortMenu(props) {
  const { mappedSortOrder, changeSortOrder, sortOrder, direction } = props;
  const activeItem = mappedSortOrder.find(
    item => item.direction === direction && item.value === sortOrder
  );
  return (
    <DropdownMenu>
      <DropdownMenuButton>
        <span>{activeItem ? activeItem.text : t('Sort By')}</span>
        {activeItem ? <Check /> : <Carot className="carot" />}
      </DropdownMenuButton>
      <DropdownMenuItems>
        {mappedSortOrder.map(sortItem => {
          return (
            <DropdownMenuItem
              onSelect={() =>
                changeSortOrder(sortItem.value, sortItem.direction)
              }
              key={sortItem.value}
            >
              {sortItem.text}
              {activeItem === sortItem && <Check />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuItems>
    </DropdownMenu>
  );
}

export default SortOrderDropdown;
